export default __webpack_public_path__ + "static/media/single-project-page-02-img15.05c84eb2.jpg";